
import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonService } from '../../service/common.service';
import { Articolo } from '../../models/articolo';
import { Catalogo } from '../../models/catalogo';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { configurazione } from '../../../configurazioni/configurazione';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ArticolitabsComponent } from './articolitabs/articolitabs.component';

@Component({
  selector: 'app-articoli',
  templateUrl: './articoli.component.html',
  styleUrls: ['./articoli.component.css'],
  providers: [ArticolitabsComponent]
})
export class ArticoliComponent implements OnInit {

  selectedValueCatalogo:string;
  articoli: Articolo[]=[];
  cataloghi: Catalogo[];
  catalogo: Catalogo;
  filtroCodicearticolo:string="";
  filtroDescrizione:string="";
  filtroLte:string="";
  filtroGte:string="";
  filtroOnlyInStock:boolean=false;
  totalElements:number=0;
  totalPages:number=0;
  currentPage:number=1;
  displayedColumns: string[] = [
    "Id",
    "Catalogo",
    "Codicecatalogo",
    "Codicearticolo",
    "Descrizione",
    "Categoria",
    "Costo",
    "Iva",
    "Prezzo",
    "Note",
    "Giacenza",
    "Unitamisura",
    "edit"];



  sortedDirection:Map<string, boolean>=new Map<string, boolean>();
  dataSource = new MatTableDataSource<Articolo>(this.articoli);

//  @ViewChild('paginator') paginator: MatPaginator;
  tabIndex = 0
  tabs : Tab[] = [
     {
       id: 'tabOne',
       name: 'A magazzino'
     },{
       id: 'tabTwo',
       name: 'Da ordinare'
     },{
       id: 'tabThree',
       name: 'Da consegnare'
     }
   ]

  constructor(private articolitabsComponent: ArticolitabsComponent, private router: Router, private commonService: CommonService) {}

  myTabFocusChange(event:any){
    if (event.index==1){
  //    this.articolitabsComponent.refreshArticolidaordinare();
    }else if (event.index==2){
  //    this.articolitabsComponent.refreshArticolidaconsegnare();
    }
  }



  ngOnInit() {

    this.commonService.getAllCataloghi().subscribe((res) => {
        this.cataloghi = res;

/*
        this.commesse.forEach(element => {
          if (element.Codice === this.commonService.currentAziendaCodice){
            this.stato=element;
            this.selectedValueAzienda=this.azienda.Nome;
          }
        });
*/
  //      this.manageChangeAzienda();
  /*
        if (this.commonService.selectedCatalogo!=undefined){
          this.selectedValueCatalogo=this.commonService.selectedCatalogo.Nome;
        }
        this.manageChangeCatalogo();
        */
    });

  //  this.dataSource.paginator = this.paginator;
    this.sortedDirection.set("Id",true);
    this.sortedDirection.set("Catalogo",true);
    this.sortedDirection.set("Codicecatalogo",true);
    this.sortedDirection.set("Codicearticolo",true);
    this.sortedDirection.set("Descrizione",true);
    this.sortedDirection.set("Categoria",true);
    this.sortedDirection.set("Costo",true);
    this.sortedDirection.set("Iva",true);
    this.sortedDirection.set("Prezzo",true);
    this.sortedDirection.set("Note",true);
    this.sortedDirection.set("Giacenza",true);
    this.sortedDirection.set("Unitamisura",true);
  }
/*
  manageChangeCatalogo(){
    if (this.selectedValueCatalogo===undefined){
     return;
    }
    this.cataloghi.forEach(element => {
      if (this.selectedValueCatalogo === element.Nome){
        this.catalogo=element;
      }
    });
    this.aggiornaLista();
  }

  cancel(){
    this.selectedValueCatalogo="";
    this.catalogo=new Catalogo();
    this.filtroLte="";
    this.filtroGte="";
    this.aggiornaLista();
  }



  delete(articolo: Articolo): void {
    this.commonService.deleteArticolo(articolo).subscribe(data => {
      this.articoli = this.articoli.filter(c => c !== articolo);
    });
  }


  aggiornaLista(){
    this.articoli=[];
      if (this.catalogo!=undefined){
       this.commonService.getAllArticoliByCatalogo(this.catalogo.Codice).subscribe((res) => {

           this.articoli=res;


  //       }
         this.refreshLista(this.articoli);
        });
      }
    }

   refreshLista(listaarticoli:Articolo[]){
     this.articoli=listaarticoli;
     this.dataSource = new MatTableDataSource<Articolo>(this.articoli);
   }

  new(){
    this.commonService.selectedArticolo=undefined;
    this.commonService.selectedCatalogo=this.catalogo;
    this.router.navigate(['addarticolo']);
  }
  edit(articolo: Articolo): void {
      this.commonService.selectedArticolo=articolo;
      this.commonService.selectedCatalogo=articolo.Catalogo;
      this.router.navigate(['addarticolo']);
  }

  goPrevPage(){
    if (this.currentPage>1){
      this.currentPage--;
      this.cerca();
    }
  }

  goNextPage(){
    if (this.currentPage<this.totalPages){
      this.currentPage++;
      this.cerca();
    }
  }

  cerca(){

    let testo=this.filtroCodicearticolo+this.filtroDescrizione;
      let searchPage=0;
      if (this.currentPage>0){
        searchPage=this.currentPage-1;
      }

      this.commonService.getArticolisearch(true, searchPage, 10, testo, Number(this.filtroLte), Number(this.filtroGte), false).subscribe(res=>{
        this.articoli=res;

        this.commonService.getArticoliSize(testo).subscribe(data=>{
          this.totalPages=data['totalPages'];
          this.totalElements=data['totalElements'];
          console.log("--->"+data['totalPages']);
          console.log("--->"+data['totalElements']);
        })


        this.refreshLista(this.articoli);

      })
  }

  onFiltroCodicearticoloKeyup(event:any){
    this.filtroDescrizione="";
  }

  onFiltroDescrizioneKeyup(event:any){
    this.filtroCodicearticolo="";
  }

  onFiltroLteKeyup(event:any){
    if (isNaN(event.target.value)){
      event.target.value=this.filtroLte;
    }else{
      this.filtroLte=event.target.value;
    }

  }

  onFiltroGteKeyup(event:any){
    if (isNaN(event.target.value)){
      event.target.value=this.filtroGte;
    }else{
      this.filtroGte=event.target.value;
    }
  }

  onFiltroOnlyInStockKeyup(event:any){
    this.filtroOnlyInStock=event.checked;
  }

  getConfigurazione(){
    return configurazione.articolo;
  }

  manageClick(attributo: string){
    let tempList:Articolo[];
    tempList=this.articoli;
    let direction=this.sortedDirection.get(attributo);

    tempList.sort((a, b) => {
       var typeA = "";
       var typeB = "";
       if (a[attributo]!=null){
         if (isNaN(b[attributo]))
            typeA = a[attributo].toLowerCase();
         else
            typeA = a[attributo].toString();
       }
       if (b[attributo]!=null){
         if (isNaN(b[attributo]))
            typeB = b[attributo].toLowerCase();
          else
            typeB = b[attributo].toString();
       }
         if (direction){
           if (typeA > typeB){
             return -1;
           }else if (typeA < typeB){
              return 1;
           }else{
             return 0;
           }
         }else{
           if (typeA < typeB){
             return -1;
           }else if (typeA > typeB){
              return 1;
           }else{
             return 0;
           }
         }
     });
     direction=!direction;
     this.sortedDirection.set(attributo,direction);
     this.dataSource = new MatTableDataSource<Articolo>(this.articoli);

   }
*/
}
export interface Tab {
  id: string;
  name: string;
}
